module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/pagination/last-d65a73ebd339b35fd808832b4a1b46d4.svg";